import { render, staticRenderFns } from "./ShopSticker.vue?vue&type=template&id=2b646d5a"
import script from "./ShopSticker.vue?vue&type=script&lang=js"
export * from "./ShopSticker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b646d5a')) {
      api.createRecord('2b646d5a', component.options)
    } else {
      api.reload('2b646d5a', component.options)
    }
    module.hot.accept("./ShopSticker.vue?vue&type=template&id=2b646d5a", function () {
      api.rerender('2b646d5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/ShopSticker.vue"
export default component.exports